import React, { useEffect, useState, useRef, memo } from "react";
import axios from 'axios';
import {
  Modal,
  Form,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import webSocket from "socket.io-client";
import { Report } from 'notiflix/build/notiflix-report-aio';
import { Loading } from "notiflix/build/notiflix-loading-aio";

import btnArrow from "../../assets/images/icons/whiteboard-menu-right-1.svg";
import btnAdd from "../../assets/images/icons/whiteboard-menu-right-2.svg";
import btnMinus from "../../assets/images/svg/minus-solid.svg";
import btnPlus from "../../assets/images/svg/plus-solid.svg";
import loading from "../../assets/images/screen/loading_2.apng.png";

import { Portal } from "../../utils/components";
import throttle from 'lodash.throttle';

import {
  setAuthorization,
  setAuthToken,
  getAuthToken,
  getTeacherAuthToken,
} from "../../utils/auth";
import {
  getUrlParameter,
  removeAuthTokenFromUrl,
  random,
  randomNumber
} from "../../utils/actions";
import {
  UsernameAction,
  TeacherUsernameAction,
  BoardListGetAction,
  BoardLastPageAction,
  BoardPageCreateAction,
  MemberListGetAction,
  CardListGetAction,
  BoardInfoGetAction,
  BackgroundCategoryGetAction,
} from "../../store/screen/actions";

import { screenState, resetboardUpdateFlag, setError, resetboardDarwDataUpdateFlag, boardPageNumSetting } from "../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import BoardPage from "./BoardPage";

const Index = () => {
  // const socketUrl = "localhost:4000";
  const socketUrl = "/";
  const dispatch = useAppDispatch();
  const { username, teacherUsername, boardData, pageInfo, errorMsg, boardUpdateSuccess, boards, boardInfo, boardElements, draw_id, drawData, boardDarwDataUpdateSuccess, stop_socket } = useAppSelector(state => screenState(state));
  const [Scale, setScale] = useState<number>(
    ( window.innerWidth / window.innerHeight ) >= 1.7777777777777777?
    window.innerHeight / 1080 :
    window.innerWidth / 1920
  );
  const [toolScale, setToolScale] = useState<number>(
    ( window.innerWidth / window.innerHeight ) >= 1.7777777777777777?
    window.innerHeight / 1080 :
    window.innerWidth / 1920
  );
  const [coverSetting, setCoverSetting] = useState<any>({
    mode: "forward",
    type: "circle",
    color: "#111827",
    size: 0
  });
  const [leftToolShow, setLeftToolShow] = useState(true);
  const [rightToolShow, setRightToolShow] = useState(true);
  const [receive, setReceive] = useState<boolean>(false);
  const [isIPad, setIsIPad] = useState<boolean>( /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document));
  const [first, setFirst] = useState(false);
  const [userInput, setUserInput] = useState<any>("");
  const [inputStatus, setInputStatus] = useState("0");
  const [showUserInputModal, setShowUserInputModal] = useState(false);
  const [pageOnReady, setPageOnReady] = useState(false);
  const [accessToken, setAccessToken] = useState<any>("");
  const [pageUpdateLoad, setPageUpdateLoad] = useState(false);
  const [boardSchedule, setBoardSchedule] = useState<any>([]);
  const [boardIdOrder, setBoardOrder] = useState<any>(null);
  const [userList, setUserList] = useState<any>([]);
  const [socket, setSocket] = useState<any>(null);
  const [socketConnected, setSocketConnected] = useState(false);
  const [socketReconnectCount, setSocketReconnectCount] = useState<any>(0);
  const [socketReset, setSocketReset] = useState(0);
  const [changePage, setChangePage] = useState<number | null>(null);
  const userBoardIdOrder = useRef<any>({
    id: null,
    index: null,
    length: 0
  });
  const boardsRef = useRef<any>(null);
  const [UserPermission, setUserPermission] = useState(false);
  const [boardConfig, setBoardConfig] = useState<any>({
    sidebar_position: "LEFT",
    tool_size: "100%"
  });
  const [pageBlock, setPageBlock] = useState<boolean>(false);
  // 
  const [spotlightSize, setSpotlightSize] = useState<number>(20);
  // 
  const [userCoverSetting, setUserCoverSetting] = useState({
    mode: "forward",
    type: "circle",
    holePercent: 20,
    centerPct: {
      xPct: 50,
      yPct: 50
    },
    tool: "cursor"
  });
  // 

  const BoardId = getUrlParameter("board");
  const teacherToken = getTeacherAuthToken();
  const token = getAuthToken();
  const user = localStorage.getItem(`username-${BoardId}`);

  useEffect(() => {
    console.log('teacherUsername', teacherUsername);

  }, [teacherUsername]);

  useEffect(() => {
    if (accessToken !== "" && boardData && !first) {
      let lastPage = 0;
      setFirst(true);
      if (boardData) {
        if (boardData.last_page && boardData.last_page !== 0) {
          lastPage = boardData.last_page;
          getBoardData(boardData.last_page);
        } else {
          getBoardData(0);
        }
        if (boardData.config) {
          setBoardConfig(boardData.config);
        }
      } else {
        getBoardData(0);
      }
      const listGet = {
        id: BoardId,
        pageNum: lastPage,
        is_deleted: false,
        stop_socket: false,
      }
      dispatch(BoardListGetAction(listGet));
      dispatch(MemberListGetAction());
      dispatch(CardListGetAction());

      if (!socket) {
        setSocket(webSocket(socketUrl, {
          transports: ["websocket"],
          rejectUnauthorized: false
        }, ));
      }
    } else if (accessToken !== "" && !boardData && !first) {
      dispatch(BoardInfoGetAction({ id: BoardId }));
      dispatch(BackgroundCategoryGetAction());
    }
  }, [accessToken, boardData, first]);

  useEffect(() => {
    if (boardUpdateSuccess) {
      boardsRef.current = boards;
      // if (boardUpdateSuccess && !pageOnReady) {
      //   setTimeout(() => {
      //     setPageOnReady(true);
      //   }, 2000);
      // }
      if (teacherUsername && !stop_socket) {
        (async () => {
          const response = await socketRequest("updateBoard", {
            boards: boards,
            changePage: changePage,
          });
          // console.log(response);
        }) ();
        setChangePage(null);
      }
      setPageBlock(false);
    }
    if (socketReset === 1) {
      setSocketReset(2);  // OK to reset socket listener in each boardPage
    }
  }, [dispatch, boardUpdateSuccess, boards]);

  useEffect(() => {
    if (!teacherToken && !token && !user && userInput === "") {
      setShowUserInputModal(true);
    }
  }, [showUserInputModal]);

  useEffect(() => {
    const chkBoardsUpdate = (newBoards: [any]) => {
      if (boardsRef.current.length !== newBoards.length) {
        return true;
      }
      for (let i = 0; i < boardsRef.current.length; i++) {
        if (boardsRef.current[i].id !== newBoards[i].id) {
          return true;
        }
      }
      return false;
    }

    const join = async (socket: any, boardId: string, token: string, userId: string | null) => {
      const joinData = {
        boardId: boardId,
        token: token,
        userId: userId,
      };
      // console.log('joinData: ', joinData);

      const response = await socketRequest("join", joinData);

      // console.log(response);
      if (response.status === "ok") {
        // // socket.removeAllListeners();
        // socket.off("someoneIn");
        // socket.on("someoneIn", (data: any) => {
        //   // console.log("in", data);
        // });
        // socket.off("someoneOut");
        // socket.on("someoneOut", (data: any) => {
        //   // console.log("out", data);
        // });

        socket.off("permissionUpdated");
        socket.on("permissionUpdated", (data: any) => {
          // console.log(data);
          setUserPermission(data.permission);
        });

        socket.off(`boardUpdated`);
        socket.on(`boardUpdated`, (data: any) => {
          // add new page / set background
          // console.log(data);
          let pageNum = 0;
          if (data.boards) {
            // console.log("changePage", data.changePage);
            // console.log(userBoardIdOrder.current);
            if (data.changePage !== null) {
              pageNum = data.changePage;
            } else {
              if (userBoardIdOrder.current.id !== null) {
                pageNum = data.boards.findIndex((item: any) => item.id === userBoardIdOrder.current.id);
                if (pageNum < 0) {
                  if (userBoardIdOrder.current.index >= data.boards.length) {
                    pageNum = data.boards.length - 1;
                  } else {
                    pageNum = userBoardIdOrder.current.index;
                  }
                }
              } else {
                pageNum = boardData?.last_page || 0;
              }
            }
            // console.log("pageNum", pageNum);

            if (chkBoardsUpdate(data.boards)) {
              // console.log("need to reset socket")
              setSocketReset(1);  // wait for boards update done
            }

            const listGet = {
              id: BoardId,
              pageNum: pageNum,
              is_deleted: false,
              stop_socket: !!teacherUsername,
            }
            dispatch(BoardListGetAction(listGet));
            dispatch(boardPageNumSetting(pageNum));
            userBoardIdOrder.current.id = data.boards[pageNum].id;
            userBoardIdOrder.current.index = pageNum;
            userBoardIdOrder.current.length = data.boards.length;
          }
          if (!teacherUsername && username && data.coverData) {
            setUserCoverSetting((prev: any) => ({
              ...prev,
              ...data.coverData, // 更新设置
            }));
          }
        });
        if (username) {
        } else {
          socket.off("updateSocketList");
          socket.on("updateSocketList", (data: any) => {
            // console.log(data);
            setUserList(data.list);
          });
        }

        setSocketConnected(true);
        console.log(`${userId ? userId : "teacher"} connected`);
      } else {
        Report.warning('重複使用者名稱進入',
          `${userId}已進入教室\n請關閉視窗\n並從官網重新進入`,
          '確定'
        );

        setSocketConnected(false);
        console.log(`${userId ? userId : "teacher"} already connected`);
      }
    }

    if (socket) {
      socket.request = ((socket: any) => {
        return function request(type: string, data: object) {
          return new Promise((resolve) => {
            socket.emit(type, data, resolve);
          });
        }
      })(socket);

      socket.off("connect");
      socket.on("connect", async () => {
        if (teacherUsername) {
          join(socket, BoardId, accessToken, teacherUsername);
        } else {
          join(socket, BoardId, accessToken, username);
        }
      });

      socket.off("connect_error");
      socket.on('connect_error', (error: any) => {
          console.log('Connection failed:', error);
          if (socketReconnectCount < 3) {
            setSocketReconnectCount(socketReconnectCount + 1);
            setTimeout(manuallyReconnect, 5000);
          } else {
            // Report.warning(
            //   '與伺服器連結中斷',
            //   '請關閉視窗\n並從官網重新進入',
            //   '確定',
            // );
          }
      });
    }
  }, [socket, boardInfo, socketReconnectCount]);

  const socketRequest = async (requestType: string, data: {}): Promise<any> => {
    if (socket) {
      return socket.request(requestType, data);
    } else {
      // nothing to do now
    }
  }

  const manuallyReconnect = () => {
    if (socket.disconnected) {
      socket.connect();
    }
  };

  if (!teacherToken) {
    setTimeout(() => {
      removeAuthTokenFromUrl();
    }, 5000);
  } else {
    setTimeout(() => {
      removeAuthTokenFromUrl();
    }, 5000);
  }
  useEffect(() => {
    if (teacherToken) {
      fetch(`${process.env.REACT_APP_API_URL}/api/board/${BoardId}`, {
        method:"GET",
        headers: {
          "Content-Type": "application/json",
          "usertoken": teacherToken,
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.status != "SUCCESS") {
          console.log("失敗", data);
        } else {
          if (data.data.role === "TEACHER") {
            setAccessToken(teacherToken);
            setAuthorization(teacherToken);
            dispatch(TeacherUsernameAction({ teacherUsername: `dGVhY2hlcg==${BoardId}_${random(6)}` }));
          } else if (data.data.role === "GUEST") {
            localStorage.clear();
            toggleUserInputModal();
          }
        }
      })
      .catch(e => {
        console.log("error", e);
      });
    } else if (!teacherToken && token && user) {
      setAccessToken(token);
      setAuthorization(token);
      dispatch(UsernameAction());
    } else {
      toggleUserInputModal();
    }
  }, []);

  const createUser = () => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/updateGuests/${BoardId}`;
    const customToken = random(32);
    setInputStatus("1");
    fetch(apiUrl, {
      method:"POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "token": customToken,
        "name": userInput
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {

      } else {
        localStorage.setItem(`username-${BoardId}`, data.data.user_name);
        setAuthToken(data.data.user_token);
        setAccessToken(data.data.user_token);
        toggleUserInputModal();
        setInputStatus("0");
        dispatch(UsernameAction());
      }
    })
    .catch(e => {
      console.log("error", e);

      dispatch(setError("用戶建立失敗"));
    });
  };

  const toggleUserInputModal = () => {
    setShowUserInputModal(!showUserInputModal);
  };

  useEffect(() => {
    if (boardSchedule.length !== 0) {
      const arr = Array.from(boardSchedule);
      const item: any = arr.splice(0, 1);
      if (item[0].id === boardInfo?.id) {
        setBoardOrder(item[0].order_num);
      }
      updatePages(item[0]);
      setBoardSchedule(arr);
    } else {
      if (boardIdOrder !== null) {
        setTimeout(() => {
          getBoardData(boardIdOrder);
          setPageUpdateLoad(false);
          // setChangePage(boardIdOrder);
        }, 1500);
      }
    }
    setSocketReset(1);  // wait for boards update done
  }, [boardSchedule]);

  const updatePages = (boardObj: any) => {
    const API_URL = process.env.REACT_APP_API_URL;
    fetch(`${API_URL}/api/updatePages/${boardObj.id}`, {
      method:"POST",
      headers: {
        "userToken": accessToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "background_id": boardObj.background_id,
        "name": boardObj.name as string,
        "content": boardObj.content,
        "order_num": boardObj.order_num
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {
        throw data;
      } else {
        console.log('updatePages', data);
      }
    })
    .catch(e => {
      console.log("error", e);

      dispatch(setError("頁面頁面更新失敗"));
    });
  };

  const getBoardData = (page: number) => {
    console.log('page', page);

    const listGet = {
      id: BoardId,
      pageNum: page,
      is_deleted: false,
      stop_socket: false,
    }
    dispatch(BoardListGetAction(listGet));
    dispatch(boardPageNumSetting(page));
    dispatch(BoardLastPageAction({ id: BoardId, page: page}));
    //
    if (boardIdOrder) {
      setBoardOrder(null);
    }
    setChangePage(page);
  };

  const addBoard = () => {
    const newPage = {
      id: BoardId,
      pageNum: pageInfo.pageNum + 1,
      is_deleted: false,
      background_id: "95VY2POlj3",
      name: "New screen",
      content: "",
      order_num: boards.length + 1
    };
    dispatch(BoardPageCreateAction(newPage));
    dispatch(BoardLastPageAction({ id: BoardId, page: pageInfo.pageNum + 1}));
    setChangePage(pageInfo.pageNum + 1);

    // setTimeout(() => {
    //   setPageBlock(false);
    // }, 1000);
  };

  const pageChange = (type: string) => {
    if (type === "prev") {
      getBoardData(pageInfo.pageNum - 1);
      userBoardIdOrder.current.id = boards[pageInfo.pageNum - 1].id;
      userBoardIdOrder.current.index = pageInfo.pageNum - 1;
      userBoardIdOrder.current.length = boards.length;
      // setChangePage(pageInfo.pageNum - 1);
    }
    if (type === "next") {
      getBoardData(pageInfo.pageNum + 1);
      userBoardIdOrder.current.id = boards[pageInfo.pageNum + 1].id;
      userBoardIdOrder.current.index = pageInfo.pageNum + 1;
      userBoardIdOrder.current.length = boards.length;
      // setChangePage(pageInfo.pageNum + 1);
    }

    // setTimeout(() => {
    //   setPageBlock(false);
    // }, 500);
  };

  const pageToThis = (page: number) => {
    const listGet = {
      id: BoardId,
      pageNum: page,
      is_deleted: false,
      stop_socket: false,
    }
    userBoardIdOrder.current.id = boards[page].id;
    userBoardIdOrder.current.index = page;
    userBoardIdOrder.current.length = boards.length;
    dispatch(BoardListGetAction(listGet));
    dispatch(boardPageNumSetting(page));
    dispatch(BoardLastPageAction({ id: BoardId, page: page}));
    if (boardIdOrder) {
      setBoardOrder(null);
    }
    setChangePage(page);
  };

  const zoomChange = (type: string) => {
    if (type === "plus") {
      setScale(Scale + 0.10);
    }
    if (type === "minus") {
      setScale(Scale - 0.10);
    }
  };



  const [activeRequests, setActiveRequests] = useState<number>(0);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(config => {
      setActiveRequests(prev => prev + 1);
      return config;
    });
    const responseInterceptor = axios.interceptors.response.use(
      response => {
        setActiveRequests(prev => prev - 1);
        if (activeRequests === 0) {
        }
        return response;
      },
      error => {
        setActiveRequests(prev => prev - 1);
        if (activeRequests === 0) {
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    if (activeRequests === 0) {
      if (accessToken) {
        timeoutRef.current = setTimeout(() => {
          setPageOnReady(true);
        }, 5000);
      }
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [activeRequests, accessToken]);

  useEffect(() => {
    if (pageBlock) {
      Loading.circle();
    } else {
      Loading.remove();
    }
  }, [pageBlock]);

  //
  const [hoverCard, setHoverCard] = useState<boolean>(false);

  useEffect(() => {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    const handlePointerMove = throttle((e: MouseEvent | TouchEvent) => {
      let clientX: number | undefined;
      let clientY: number | undefined;

      if ('touches' in e && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else if ('clientX' in e) {
        clientX = e.clientX;
        clientY = e.clientY;
      }
      if (clientX == null || clientY == null) return;

      const elements = document.elementsFromPoint(clientX, clientY);
      const cardIndex = elements.findIndex(el =>
        el.hasAttribute('data-target-type') &&
        el.getAttribute('data-target-type') === 'WIDGET_CARD'
      );

      const foundBlockingElement = elements.slice(0, cardIndex).find(el =>
        el.hasAttribute('data-target-type') &&
        el.getAttribute('data-target-type') !== 'WIDGET_CARD' &&
        el.getAttribute('data-target-type') !== 'toolbar' &&
        window.getComputedStyle(el).pointerEvents !== 'none' &&
        window.getComputedStyle(el).visibility !== 'hidden'
      );

      setHoverCard(!foundBlockingElement);
    }, 100);

    const eventType = isTouchDevice ? 'touchstart' : 'mousemove';
    window.addEventListener(eventType, handlePointerMove, { passive: true });

    return () => {
      window.removeEventListener(eventType, handlePointerMove);
      handlePointerMove.cancel?.();
    };
  }, []);
  
  const handleReceive = () => {
    setReceive(!receive);
  };

  return (
    <React.Fragment>
      {!pageOnReady? (
        <>
          <div className="ready-load">
            <img 
              src={loading} 
              style={{ height: "30vh" }}
              alt=""
            />
            <Modal id="studentSettingsModal" className="h-100 w-100 items-center justify-center sm:p-14 m-auto" isOpen={showUserInputModal} toggle={toggleUserInputModal} modalClassName="zoomIn" zIndex={1000120} autoFocus={false} centered>
              <Form
                onSubmit={e => {
                  e.preventDefault();
                  return false;
                }}
              >
                <div className="relative rounded-lg bg-white text-left shadow-xl overflow-y-auto overflow-x-hidden max-h-full w-full max-w-xs sm:max-w-3xl md:max-w-5xl">
                  <div>
                    <div className="setting-box w-100">
                      <div className="basis-1/2 lg:basis-3/5 xl:basis-2/3">
                        <div className="mb-4">
                          <label htmlFor="title" className="crs-subtitle"> 學生名稱 </label>
                        </div>
                        <Input
                          id="title"
                          name="title"
                          type="text"
                          className="crs-text-input mt-2"
                          defaultValue={userInput}
                          onChange={(e: any) => setUserInput(e.target.value)}
                          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                            // 重要：IMEs（中文輸入法）組字中的 Enter 不觸發提交
                            // @ts-ignore
                            if ((e.nativeEvent as any).isComposing) return;
                            if (e.key === "Enter") {
                              e.preventDefault();
                              if (inputStatus !== "1") createUser();
                            }
                          }}
                          autoFocus={true}
                        />
                        <div className="mt-3">
                          <Button
                            className="rounded-pill student-btn"
                            variant="contained"
                            onClick={() => createUser()}
                          >
                            {inputStatus === "0"? (
                              <span>繼續</span>
                            ) : inputStatus === "1"? (
                              (
                                <span className="ts-load d-flex justify-center items-center">
                                  <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                                </span>
                              )
                            ) : null}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Modal>
          </div>
        </>
      ) : (
        <React.Fragment>
          <div
            id="app"
            className={`${ username? "studentSide" : "" } ${ isIPad? "nowIsIPad" : "" }`}
            style={{ "--zoom": Scale }}
          >
            {boards.map((item: any, index: number) => (
              <div
                key={item.id}
                className={`board-box ${pageInfo.pageNum !== index? "hide-board" : ""}`}
              >
                <BoardPage
                  accessToken={accessToken}
                  pageToThis={pageToThis}
                  pageUpdateLoad={pageUpdateLoad}
                  setPageUpdateLoad={setPageUpdateLoad}
                  setBoardSchedule={setBoardSchedule}

                  socket={socket}
                  socketRequest={socketRequest}
                  socketConnected={socketConnected}
                  socketReset={socketReset}
                  setSocketReset={setSocketReset}
                  setChangePage={setChangePage}

                  boardInfo={item}

                  userList={userList}
                  setUserList={setUserList}

                  UserPermission={UserPermission}
                  zoom={Scale}

                  nowPage={pageInfo.pageNum === index}

                  boardConfig={boardConfig}

                  hoverCard={hoverCard}

                  leftToolShow={leftToolShow}
                  setLeftToolShow={setLeftToolShow}
                  rightToolShow={rightToolShow}
                  setRightToolShow={setRightToolShow}

                  coverSetting={coverSetting}
                  setCoverSetting={setCoverSetting}

                  receive={receive}
                  handleReceive={handleReceive}
                  toolScale={toolScale}

                  spotlightSize={spotlightSize}
                  setSpotlightSize={setSpotlightSize}
                  userCoverSetting={userCoverSetting}
                  setUserCoverSetting={setUserCoverSetting}
                />
              </div>
            ))}

            <div 
              style={{
                transform: `scale(${ toolScale })`,
                left: `calc(16px * ${ toolScale })`,
                bottom: `calc(24px * ${ toolScale })`,
              }}
              className={`bottom-tool bt-left`}
            >
              <div className="flex flex-row">
                <button className="tool-prev"  onClick={() => zoomChange("minus")}>
                  <img className="board-page-btn-prev" src={btnMinus} alt="" />
                </button>
                <div className="tool-page">{`${Math.floor(Scale * 100)}%`}</div>
                <button className="tool-next"  onClick={() => zoomChange("plus")}>
                  <img className="board-page-btn-prev" src={btnPlus} alt="" />
                </button>
              </div>
            </div>

            <div
              style={{
                transform: `scale(${ toolScale })`,
                right: `calc(16px * ${ toolScale })`,
                bottom: `calc(24px * ${ toolScale })`,
              }}
              className={`bottom-tool`}
            >
              <div className="flex flex-row">
                <button className="tool-prev" onClick={() => {pageChange("prev"); setPageBlock(true);}} disabled={pageInfo.pageNum === 0 || pageBlock}>
                  <img className="board-page-btn-prev" src={btnArrow} alt="" />
                </button>
                <div className={`tool-page ${pageBlock? "disabled-page-number" : ""}`}>{pageInfo.pageNum + 1}/{pageInfo.total}</div>
                {pageInfo.pageNum + 1 !== pageInfo.total? (
                  <button className="tool-next" onClick={() => {pageChange("next"); setPageBlock(true);}} disabled={pageBlock}>
                    <img className="board-page-btn-next" src={btnArrow} alt="" />
                  </button>
                ) : (
                  <>
                    {teacherUsername? (
                      <button className="tool-next" onClick={() => {addBoard(); setPageBlock(true);}} disabled={pageBlock}>
                        <img className="board-page-btn-add" src={btnAdd} alt="" />
                      </button>
                    ) : (
                      <button className="tool-next" disabled>
                        <img className="board-page-btn-next" src={btnArrow} alt="" />
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default memo(Index);